import React, { useCallback, useMemo } from 'react';

import { Link } from 'react-router-dom';
import Tooltip from 'react-bootstrap/Tooltip';

import Rate from 'components/barbr/Rate/index';
import Space from 'components/barbr/Space/index';
import { VerificationIcon, UserIcon } from 'components/Icon';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { toFixed } from '_dash';
import { getProfileRoute } from 'appRoutes/routeHelpers';
import greenLogo from 'assets/green-logo.svg';

const BarberProfileMetaChip = React.memo(({ detail, linkToProfile = false, ratingClassName }) => {
  const { username } = detail;
  const name = detail.name || detail.display_name;

  const reviewCount = useMemo(() => {
    const reviewsCount = detail.number_reviews || 0;
    let value = reviewsCount;
    if (reviewsCount >= 50 && reviewsCount < 200) {
      const mod25 = reviewsCount % 25;
      value = `${mod25 ? reviewsCount - mod25 : reviewsCount}+`;
    }
    if (reviewsCount >= 200 && reviewsCount < 1000) {
      const mod50 = reviewsCount % 50;
      value = `${mod50 ? reviewsCount - mod50 : reviewsCount}+`;
    }
    if (reviewsCount > 1000) {
      const mod100 = reviewsCount % 100;
      value = `${mod100 ? reviewsCount - mod100 : reviewsCount}+`;
    }
    return value;
  }, [detail.number_reviews]);

  const renderLinkNode = useCallback(
    (node) => {
      if (linkToProfile) {
        return <Link to={getProfileRoute(username)}>{node}</Link>;
      }
      return node;
    },
    [linkToProfile, username]
  );

  return (
    <Space className='barber-profile-meta-chip' size={18}>
      <Choose>
        <When condition={detail.image}>
          {renderLinkNode(<img width={48} height={48} alt={name} src={detail.image} className='circle-radius' loading='lazy' />)}
        </When>
        <Otherwise>{renderLinkNode(<UserIcon size={48} />)}</Otherwise>
      </Choose>

      <div>
        <OverlayTrigger
          placement='top'
          overlay={
            <Tooltip className='verification-tooltip'>
              <p>Verified by</p>
              <img src={greenLogo} alt='barbr' loading='lazy' />
            </Tooltip>
          }>
          {({ ref, ...triggerHandler }) => (
            <div {...triggerHandler}>
              <Space align='center' size={6}>
                {renderLinkNode(<p className='text-2xl name semi-bold'>{name}</p>)}
                <If condition={detail.is_verified}>
                  <div ref={ref} style={{ marginTop: '-0.4rem' }}>
                    <VerificationIcon size={16} />
                  </div>
                </If>
              </Space>
            </div>
          )}
        </OverlayTrigger>
        <Space align='center' size={6} className={ratingClassName ? ratingClassName : ''}>
          <Rate count={1} value={100} disabled size={20} />
          <p className='text-xl' style={{ marginTop: '0.3rem' }}>
            <span className='text-xl primary'>{toFixed(parseFloat(detail.avg_rating || 0), 1)}</span> <span className='text-xl light'>({reviewCount})</span>
          </p>
        </Space>
      </div>
    </Space>
  );
});

export default BarberProfileMetaChip;
